import { takeLatest, put, call, select, all } from 'redux-saga/effects';
import ApiSuggestions from '../sdk/suggestions/ApiSuggestions';
import { FETCH_SUGGESTIONS_REQUEST } from './constants';
import { getTypeId } from '../Serp/selectors';
import * as actions from './actions';
import { getCountryCode, getVerticalName } from '~/common/selectors/config';

export function* fetchSuggestionsRequest() {
  try {
    const countryCode = yield select(getCountryCode);
    const verticalName = yield select(getVerticalName);

    const dealTypeId = verticalName === 'homes' ? yield select(getTypeId) : null;

    yield put(actions.fetchSuggestionsStart());
    const data = yield call([ApiSuggestions, ApiSuggestions.fetchSuggestions], {
      countryCode,
      verticalName,
      dealTypeId,
    });
    yield put(actions.fetchSuggestionsSuccess(data));
  } catch (error) {
    yield put(actions.fetchSuggestionsFailed(error));
  }
}

export default function* suggestionsSagas() {
  yield all([takeLatest(FETCH_SUGGESTIONS_REQUEST, fetchSuggestionsRequest)]);
}



// WEBPACK FOOTER //
// ./app/Suggestions/sagas.js